﻿import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useIODelete } from "@/hooks/histories/useIODetail";

export function useInUseHistoryActions(listType = null, filters = null) {
	const navigate = useNavigate();
	const deleteMutation = useIODelete(listType, filters);

	const handleEdit = (historyId) => {
		navigate(`/historiales/en_uso?action=editar&id=${historyId}`);
	};

	const handleAssignOA = useCallback(
		(outputCode, balanceId) => {
			navigate(`/historiales/en_uso?action=asignar-oa&output_code=${encodeURIComponent(outputCode)}&balance_id=${balanceId}`);
		},
		[navigate],
	);

	const handleDelete = async (historyId) => {
		try {
			await deleteMutation.mutateAsync(historyId);
			toast.success("Aplicación eliminada correctamente.");
		} catch (error) {
			toast.error(error?.response?.data?.message || "Error al eliminar la aplicación");
		}
	};

	return {
		handleEdit,
		handleAssignOA,
		handleDelete,
		isDeleting: deleteMutation.isLoading,
	};
}
